/**
 * AMOXTLI - Theme Service
 * 
 * Propiedad Intelectual: Soluciones TecnoExpertas SAPI de CV
 * Autor: Luis Alberto Orozco Arias
 * Licencia: Propietaria - Todos los derechos reservados © 2026
 * 
 * Descripción: Servicio para manejar temas, persistencia y aplicación de estilos
 */

import { THEMES, DEFAULT_THEME, getTheme } from '../themes/themes'

const STORAGE_KEY = 'app_theme'
const LEGACY_THEME_IDS = {
  fiscalyaAI: DEFAULT_THEME,
}

const normalizeThemeId = (themeId) => {
  if (THEMES[themeId]) {
    return themeId
  }

  return LEGACY_THEME_IDS[themeId] || DEFAULT_THEME
}

export const themeService = {
  /**
   * Obtiene el tema guardado o el tema por defecto
   */
  getCurrentTheme: () => {
    const saved = localStorage.getItem(STORAGE_KEY)
    const themeId = normalizeThemeId(saved || DEFAULT_THEME)
    if (saved && saved !== themeId) {
      localStorage.setItem(STORAGE_KEY, themeId)
    }
    return getTheme(themeId)
  },

  /**
   * Guarda el tema seleccionado
   */
  setTheme: (themeId) => {
    const normalizedThemeId = normalizeThemeId(themeId)
    localStorage.setItem(STORAGE_KEY, normalizedThemeId)
    return getTheme(normalizedThemeId)
  },

  /**
   * Obtiene el ID del tema actual
   */
  getCurrentThemeId: () => {
    const saved = localStorage.getItem(STORAGE_KEY)
    const themeId = normalizeThemeId(saved || DEFAULT_THEME)
    if (saved && saved !== themeId) {
      localStorage.setItem(STORAGE_KEY, themeId)
    }
    return themeId
  },

  /**
   * Reseta al tema por defecto
   */
  resetToDefault: () => {
    localStorage.removeItem(STORAGE_KEY)
    return getTheme(DEFAULT_THEME)
  },

  /**
   * Obtiene lista de todos los temas disponibles
   */
  getAvailableThemes: () => {
    return Object.values(THEMES).map(theme => ({
      id: theme.id,
      name: theme.name,
      description: theme.description,
      colors: theme.colors,
      tailwind: theme.tailwind
    }))
  }
}
